import { FloatingPanelSeparator } from "@babackapp/ui/components/floating-panel";
import { NodePanelProps, PanelContainer } from "../../lib/panel/panel-container";
import { ConditionNodeData } from "../node-types";
import { PanelOperator } from "./panel-operator";
import { PanelConditions } from "./panel-conditions";


export function ConditionNodePanel(props: NodePanelProps<ConditionNodeData>) {
  return (
    <PanelContainer nodeProps={props}>
      <PanelOperator />
      <FloatingPanelSeparator />
      <PanelConditions />
    </PanelContainer>
  );
}
